<script lang="ts" setup>
defineProps<{
  open: boolean;
  title?: string;
}>();

const emit = defineEmits<{
  (e: "close"): void;
}>();
</script>

<template>
  <transition name="slide">
    <div v-if="open" class="info-panel">
      <div class="info-panel__header">
        <span class="info-panel__title">{{ title || "Info" }}</span>
        <span
          class="material-symbols-outlined icon clickable"
          @click="emit('close')"
        >
          close
        </span>
      </div>
      <div class="info-panel__content">
        <slot />
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.info-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 360px;
  height: 100%;
  background: var(--classic-surface, #fff);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 200;
  display: flex;
  flex-direction: column;
}

.info-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2em 1.5em;
  border-bottom: 1px solid var(--classic-border-subtle, $border-light);
}

.info-panel__title {
  font-size: 1.1em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.5em;
}

.info-panel__content {
  flex: 1;
  overflow-y: auto;
  padding: 1.5em;
}

.icon {
  font-size: 1.1em;
  border: 1px solid var(--classic-border-subtle, $border-light);
  border-radius: 50%;
  padding: 0.58em;
  line-height: 1;
  cursor: pointer;
}

.icon:hover {
  background: var(--classic-surface-hover, $light-grey);
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
</style>
